
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { memo } from 'react';
import PageLoader from 'global/Loading/PageLoader';
import SEO from 'global/SEO';
import useProtectedRoute from 'hooks/useProtectedRoute';
import MainLayout from 'global/MainLayout';
import Paywall from 'features/paywall/Wrapper/Page';

import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import { selectors } from 'global/MainLayout/slice';

const OrderbookFeature = dynamic(() => import('features/orderbook'), {
  ssr: false,
});

const Orderbook = () => {
  const { isLoaded } = useProtectedRoute();
  const { isSideWidgetOpen } = useSelector(selectors);

  return (
    <>
      <SEO title="Stockbit Orderbook" />
      <MainLayout maxWidth={isSideWidgetOpen ? 980 : 1440}>
        <PageLoader loaded={isLoaded} />
        <Paywall feature="ORDERBOOK">
          <OrderbookFeature />
        </Paywall>
      </MainLayout>
    </>
  );
};

export default memo(Orderbook);
